import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'management-os-auth',
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

// リフレッシュトークンエラー時にセッションをクリアする
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED' && !session) {
    // トークンリフレッシュ失敗 → ローカルストレージのセッション情報を削除
    localStorage.removeItem('management-os-auth');
  }
});

// アプリ固有の識別子（他のReaddyアプリとのデータ分離用）
export const APP_ID = 'management-os-app-001';
